import { render, staticRenderFns } from "./AddMain.vue?vue&type=template&id=1adf85a6&scoped=true&"
import script from "./AddMain.vue?vue&type=script&lang=js&"
export * from "./AddMain.vue?vue&type=script&lang=js&"
import style0 from "./AddMain.vue?vue&type=style&index=0&id=1adf85a6&lang=scss&"
import style1 from "./AddMain.vue?vue&type=style&index=1&id=1adf85a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf85a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1adf85a6')) {
      api.createRecord('1adf85a6', component.options)
    } else {
      api.reload('1adf85a6', component.options)
    }
    module.hot.accept("./AddMain.vue?vue&type=template&id=1adf85a6&scoped=true&", function () {
      api.rerender('1adf85a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseinvoice/AddMain.vue"
export default component.exports